import React from 'react';
function BackUp({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 14L4 9l5-5" />
      <path strokeLinecap="round" strokeLinejoin="round" d="M20 20v-7a4 4 0 00-4-4H4" />
    </svg>
  );
}

export default BackUp;
